@let lockState = state();
<div class="trading-lock">
    <span
        class="trading-lock__state"
        role="status"
        [class.trading-lock__state--locked]="lockState.kind === 'locked'"
        [class.trading-lock__state--unlocked]="freeToTrade()"
    >
        @switch (lockState.kind) {
            @case ("locked") {
                Locked
                @if (lockState.lockedSinceUtc) {
                    since {{ lockState.lockedSinceUtc | date: "yyyy-MM-dd HH:mm" : "UTC" }} UTC
                }
            }
            @case ("unlocked") {
                @if (freeToTrade()) {
                    Not locked
                } @else {
                    Not locked on its own
                }
            }
            @default {
                Unknown
            }
        }
    </span>
    <span class="trading-lock__actions">
        <button
            mat-stroked-button
            type="button"
            [disabled]="busy()"
            disabledInteractive
            [attr.aria-label]="'Lock trading for ' + targetName()"
            (click)="lock()"
        >
            <mat-icon>lock</mat-icon>
            Lock
        </button>
        <button
            mat-stroked-button
            type="button"
            [disabled]="busy()"
            disabledInteractive
            [attr.aria-label]="'Unlock trading for ' + targetName()"
            (click)="unlock()"
        >
            <mat-icon>lock_open</mat-icon>
            Unlock
        </button>
    </span>
</div>
